import { AdminUserMembersResponse } from "../contracts/AdminUserMembersResponse";
import { AdminUserMembers } from "../models/AdminUserMembers";

export const mapResponseToAdminUserMembers = (
  response: AdminUserMembersResponse
): AdminUserMembers => ({
  instructorId: response.instructorId,
  firstName: response.firstName,
  lastName: response.lastName,
  email: response.email,
  members: response.members.map((member) => ({
    id: member.id,
    firstName: member.firstName,
    lastName: member.lastName,
    email: member.email,
    isMinor: member.isMinor,
    tags: member.tags ?? [],
    dateCreated: new Date(member.dateCreated),
    block: member.block ?? null,
  })),
});
